'use client'
/**
 * Class implementing the fetch service with a configurable fetch implementation.
 */
class FetchService {
    static get implementation() {
        if (!FetchService._implementation) {
            return { fetch: window.fetch.bind(window) };
        }
        return FetchService._implementation;
    }
    static setImplementation(implementation) {
        FetchService._implementation = implementation;
    }
    static get fetch() {
        return FetchService.implementation.fetch;
    }
}

export { FetchService };
